var banner = {
  "fields": {
    "id": {
      "name": "id",
      "type": "ID",
      "readonly": 3,
      "options": null
    },
    "name": {
      "name": "name",
      "type": "STRING",
      "readonly": false,
      "options": null
    },
    "html": {
      "name": "html",
      "type": "STRING",
      "readonly": false,
      "options": null
    },
    "url": {
      "name": "url",
      "type": "STRING",
      "readonly": false,
      "options": null
    }
  },
  "attachments": {
    "images": {
      "name": "images",
      "extensions": ["png", "jpg"],
      "maxFileCount": 0,
      "maxFileSize": 819200,
      "meta": null
    }
  },
  "relations": []
};
export default banner;